module.exports = "<div class=\"embed-responsive embed-responsive-16by9\">\n    <iframe class=\"embed-responsive-item\" [src]=\"_embedUrl\" allowfullscreen></iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/embed/embed.component.html
// module id = ./src/app/embed/embed.component.html
// module chunks = main